import { useState, useEffect } from "react";

function FilterBar({
  onChange,
  dataInicial,
  dataFinal,
  autoLoad = true
}) {

  function formatDate(date) {
    return date.toISOString().split("T")[0];
  }

  const hoje = new Date();
  const primeiroDiaMes = new Date(hoje.getFullYear(), hoje.getMonth(), 1);

  const [inicio, setInicio] = useState(
    dataInicial || formatDate(primeiroDiaMes)
  );

  const [fim, setFim] = useState(
    dataFinal || formatDate(hoje)
  );

  // 🔥 Dispara filtro inicial
  useEffect(() => {
    if (onChange && autoLoad) {
      onChange({ inicio, fim });
    }
  }, []);

  function aplicar() {
    if (onChange) onChange({ inicio, fim });
  }

  return (
    <div className="row filter-line g-2 align-items-center">
      <div className="col-auto" style={{ minWidth: 120 }}>
        <input
          type="date"
          className="form-control form-control-sm"
          value={inicio}
          onChange={(e) => setInicio(e.target.value)}
        />
      </div>

      <div className="col-auto" style={{ minWidth: 120 }}>
        <input
          type="date"
          className="form-control form-control-sm"
          value={fim}
          onChange={(e) => setFim(e.target.value)}
        />
      </div>

      <div className="col-auto">
        <button
          type="button"
          className="btn btn-primary btn-sm"
          onClick={aplicar}
          title="Aplicar filtro"
        >
          <i className="fa fa-filter"></i>
        </button>
      </div>
    </div>
  );
}

export default FilterBar;
